import React, { useContext, useState } from 'react';
import { CheckboxGroup, Checkbox } from 'chaoskit/src/components';

import {
  ReliabilityHelp,
  ReliabilityHelpTrigger,
  ReliabilityInput,
} from '../../pages/reliability-calculator';
import { ReliabilityCalculatorContext } from './Context';

const Step3 = () => {
  const {
    state: { step3 },
    dispatch,
  } = useContext(ReliabilityCalculatorContext);
  const [helpOpen, toggleHelpOpen] = useState(false);
  const [disableInput, setDisableInput] = useState(false);

  return (
    <div className="reliabilityCalculator__cell">
      {helpOpen ? (
        <ReliabilityHelp
          title="Mean time to recover"
          toggleHelpOpen={toggleHelpOpen}
        >
          <p>
            Mean time to recover (MTTR, also “mean time to repair”) describes
            how long it takes your system to return to normal operation—whether
            that is automatically or from your team’s intervention.
          </p>
          <p>
            Time to recover (TTR) is the duration from when an incident
            <em>begins</em> to when it is fully resolved. MTTR is the average of
            this duration across all incidents.
          </p>
          <p>
            <em>
              * Note that MTTR considers when an incident{' '}
              <strong>begins</strong>, not when it is <strong>detected</strong>.
            </em>
          </p>
        </ReliabilityHelp>
      ) : (
        <div className="hero-titleWrapper u-contrast">
          <h1 className="hero-title">
            What is the{' '}
            <ReliabilityHelpTrigger onClick={() => toggleHelpOpen(!helpOpen)}>
              mean time to recover
            </ReliabilityHelpTrigger>{' '}
            (MTTR) for this service?
          </h1>
        </div>
      )}
      <ReliabilityInput
        name="mttr-input"
        onChange={(name, value) =>
          dispatch({
            type: 'choice',
            payload: {
              step3: value,
            },
          })
        }
        disabled={disableInput}
        value={step3}
        explanationMessage="Measured in hours"
      />
      <CheckboxGroup className="reliabilityCalculator__checkbox u-contrast">
        <Checkbox
          name="mttr-checkbox"
          onChange={(name, value, checked) => {
            if (checked) {
              dispatch({
                type: 'choice',
                payload: {
                  step3: 0,
                },
              });
            }

            setDisableInput(checked);
          }}
          label="We don’t currently measure MTTR"
          value="0"
        />
      </CheckboxGroup>
    </div>
  );
};

export default Step3;
